import { render } from "./TextusForm.vue?vue&type=template&id=534b6e0c&scoped=true"
import script from "./TextusForm.js?vue&type=script&lang=js&external"
export * from "./TextusForm.js?vue&type=script&lang=js&external"

import "./TextusForm.vue?vue&type=style&index=0&id=534b6e0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534b6e0c"]])

export default __exports__